import React from 'react'

const ColumnOther = () => {
  return (
    <div>ColumnOther</div>
  )
}

export default ColumnOther